module.exports = __webpack_public_path__ + "img/MG-tittle-01.a11b6da8.png";